/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choose_Existing_T2Inputs */

const en_plan_choose_existing_t2 = /** @type {(inputs: Plan_Choose_Existing_T2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse codebase`)
};

const id_plan_choose_existing_t2 = /** @type {(inputs: Plan_Choose_Existing_T2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisis codebase`)
};

/**
* | output |
* | --- |
* | "Analyse codebase" |
*
* @param {Plan_Choose_Existing_T2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const plan_choose_existing_t2 = /** @type {((inputs?: Plan_Choose_Existing_T2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choose_Existing_T2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_plan_choose_existing_t2(inputs)
	return en_plan_choose_existing_t2(inputs)
});